import { createRouter, createWebHistory } from 'vue-router';
import Landing from '../views/Landing.vue';
import Home from '../views/Home.vue';

const routes = [
  { path: '/', name: 'landing', component: Landing },
  { path: '/cadastro', name: 'home', component: Home },
  { path: '/site', name: 'site', component: () => import('../views/Site.vue') },
  { path: '/cobranca', name: 'cobranca', component: () => import('../views/Cobranca.vue') },
  { path: '/finalizar', name: 'finalizar', component: () => import('../views/Finalizar.vue') },
  { path: '/concluido', name: 'concluido', component: () => import('../views/Completo.vue') },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
export { router };